import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { postRequest as post } from '../utils/HttpMethods';
import { useNotification } from '@refinedev/core';
import * as Sentry from '@sentry/react';

interface GenerateFamilyMedicinePDFResponse {
  statusCode: number;
  message: string;
}

const parseFamilyMedicineFiles = async ({
  fileNames,
  siteID,
}: {
  fileNames: string[];
  siteID: string;
}) => {
  const response: GenerateFamilyMedicinePDFResponse = await post(
    'QBilling',
    '/action/parse/familyMedicine',
    {
      fileNames,
      siteID,
    }
  );
  try {
    if (!response || response.statusCode !== 200) {
      throw new Error(`Failed to parse Family Medicine files`);
    }
    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error('Failed to parse Family Medicine files');
  }
};

export const useParseFamilyMedicineFiles =
  (): UseMutationResult<GenerateFamilyMedicinePDFResponse> => {
    const { open } = useNotification();
    return useMutation({
      mutationFn: parseFamilyMedicineFiles,
      onError: (error) => {
        open({
          message: 'Error parsing Family Medicine files',
          description: error.message,
          type: 'error',
        });
      },
      onSuccess: () => {
        open({
          message: 'Family Medicine files parsed successfully',
          description:
            'The Family Medicine files have been parsed successfully.',
          type: 'success',
        });
      },
    });
  };
